// extracted by mini-css-extract-plugin
export default {"container":"UploadFile_container__+GXkW","uploadedFile":"UploadFile_uploadedFile__rrwTB"};